import { GetCompanyBankStatementUploadUrl } from './getCompanyBankStatementUploadUrl';
import axios from 'axios';

/** Action creators */
export const UploadCompanyBankStatement = async (contentType, objectUrl) => {
  const uploadUrl = await GetCompanyBankStatementUploadUrl({
    contentType
  });
  const response = await axios({
    url: objectUrl,
    method: 'GET',
    responseType: 'blob' // important
  });
  const blob = new Blob([response.data]);
  await axios.put(uploadUrl, blob, {
    headers: {
      'Content-Type': contentType
    }
  });
  return uploadUrl;
};
